import { Theme, alpha } from '@mui/material';

import { disabledOpacity } from '/common/theme';

export const getTextColor = (disabled?: boolean, defaultColor = 'text.primary') =>
  disabled ? 'text.disabled' : defaultColor;

export const getThemeTextColor = (disabled: boolean | undefined, theme: Theme, defaultColor?: string) =>
  disabled ? theme.palette.text.disabled : (defaultColor ?? theme.palette.text.primary);

export const getOpacity = (disabled?: boolean, defaultOpacity = 1) => (disabled ? disabledOpacity : defaultOpacity);

export const getThemeOpacity = (disabled: boolean | undefined, theme: Theme, defaultOpacity = 1) =>
  disabled ? theme.palette.action.disabledOpacity : defaultOpacity;

export const getColor = (disabled: boolean | undefined, color: string) =>
  disabled ? alpha(color, disabledOpacity) : color;
